import { LoginFormData, LoginStepProps } from "./StepModel";
import { useNavigate } from "react-router-dom";
import { Dispatch, SetStateAction } from "react";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { selectLoading, validateUser } from "../LoginPageSlice";
import CPLPasswordInput from "cpl-react-common/components/Inputs/CPLPasswordInput";
import { useSelector } from "react-redux";

export const PasswordStep: React.FC<LoginStepProps> = ({ formikProps, onInputChange }: LoginStepProps) => {
  const loading = useSelector(selectLoading);
  const navigate = useNavigate();
  return (
    <>
      {/* begin::Form group */}
      <div className="fv-row mb-3">
        <label className="form-label fw-bolder fs-6 mb-0" htmlFor="password">
          Password
        </label>
        <CPLPasswordInput
          className="form-control bg-transparent"
          id="password"
          autocomplete="current-password"
          data-test-id="login-form__password-input"
          getFieldProps={formikProps.getFieldProps}
          onChange={(event: { target: { value: SetStateAction<string> } }) => {
            formikProps.setFieldValue("password", event.target.value);
            onInputChange();
          }}
        />
      </div>
      {/* end::Form group */}
      {/* begin::Wrapper */}
      <div className="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
        <div />

        <button
          type="button"
          disabled={loading}
          className="cpl-btn cpl-btn-link"
          data-test-id="login-form__forgot-password-link"
          onClick={() => navigate(`/auth/forgot-password/${formikProps.values.emailAddress}`)}
        >
          Forgot your password?
        </button>
      </div>
      {/* end::Wrapper */}
    </>
  );
};

export const PasswordSubmit = (
  values: LoginFormData,
  dispatch: Dispatch<AnyAction>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  thunkDispatch: ThunkDispatch<any, any, any>
) => {
  thunkDispatch(validateUser({ emailAddress: values.emailAddress, password: values.password }));
};
